import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { restartableTask, timeout } from 'ember-concurrency';
import Component from '@glimmer/component';
import BvTextField from 'volta/components/bv-text-field';
import BvIcon, { type BvIconSignature } from 'volta/components/bv-icon';
import orElse from 'volta/helpers/or-else';
import perform from 'ember-concurrency/helpers/perform';
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import or from 'ember-truth-helpers/helpers/or';
import { t } from 'ember-intl';
import type { IResourceName } from 'volta/models/base-model';
const DEBOUNCE_MS = 250;
interface BvFiltersSearchInputSignature {
    Args: {
        iconColor?: BvIconSignature['Args']['color'];
        focused?: boolean;
        disabled?: boolean;
        resourceName: IResourceName;
        onSearchBlur?: (e: Event) => void;
        onSearchFocus?: (e: Event) => void;
        filterValues: TFilterValues;
        onSearchChange?: (filterValues: TFilterValues, query: string) => Promise<unknown> | unknown;
        searchValue?: string;
        placeholder?: string;
    };
    Element: HTMLElement;
}
export default class BvFiltersSearchInputComponent extends Component<BvFiltersSearchInputSignature> {
    searchTask = restartableTask(async (query: string)=>{
        const { onSearchChange, filterValues } = this.args;
        await timeout(DEBOUNCE_MS);
        return (await onSearchChange?.({
            ...filterValues
        }, query)) as unknown;
    });
    static{
        template_fd9b2463e5f141cfb5666b64daa1f11a(`
    {{#let
      (component
        BvIcon glyph='search' class='bv-filters__search-icon' color=(orElse @iconColor 'icon')
      )
      as |Icon|
    }}
      <BvTextField
        @placeholder={{orElse
          @placeholder
          (t 'bvFilters.filter' resourceName=(t @resourceName.plural))
        }}
        @onChange={{perform this.searchTask}}
        @onBlur={{optional @onSearchBlur}}
        @onFocus={{optional @onSearchFocus}}
        @value={{@searchValue}}
        @disabled={{@disabled}}
        @focused={{@focused}}
        @label={{or @placeholder (t 'bvFilters.filter' resourceName=@resourceName.plural)}}
        @labelHidden={{true}}
        @prefix={{Icon}}
        @clearButton={{true}}
        @onClearButtonClick={{perform this.searchTask ''}}
        @name='search-query'
        ...attributes
      />
    {{/let}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'BvFilters::SearchInput': typeof BvFiltersSearchInputComponent;
        'bv-filters/search-input': typeof BvFiltersSearchInputComponent;
    }
}
